import React from 'react';
import { Countdown } from './Countdown';
import { ClockIcon } from 'lucide-react';
export function TopBanner() {
  return <div className="bg-gold-500 text-navy-900 py-2 px-4 sticky top-0 z-50 shadow-md" data-id="element-308">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm sm:text-base font-bold" data-id="element-309">
        <div className="flex items-center gap-2" data-id="element-310">
          <ClockIcon className="w-4 h-4 animate-pulse" data-id="element-311" />
          <span className="uppercase tracking-wide" data-id="element-312">
            OFERTA DE LANZAMIENTO ACTIVA — Termina hoy
          </span>
        </div>
        <Countdown className="!text-navy-900 scale-75 sm:scale-90 origin-left" initialHours={23} initialMinutes={47} initialSeconds={24} data-id="element-313" />
      </div>
    </div>;
}